export default __webpack_public_path__ + "static/media/download-library-file.c94834ab.svg";